import React from 'react';
import * as Icon from '@mui/icons-material';

const Icono = ({ nombre, color }: { nombre: string; color: string }) => {
  const ComponenteIcono = (Icon as any)[nombre];

  return <ComponenteIcono style={{ color }} />;
};

export default Icono;
